module.exports = __webpack_public_path__ + "static/media/icon-btn-whatsapp.8789cb02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-btn-whatsapp.svg
// module id = 535
// module chunks = 0